export default class HtmlCache {
	private map = {};

	get(id: string, loader: Function): Promise<string> {
		if (!this.map[id]) {
			let value;
			try {
				value = loader(id);
			} catch (e) {
				value = Promise.resolve('');
			}
			this.map[id] = value;
			return value;
		}
		return this.map[id];
	}

	getWithVariationIdAndBenefitId(variationId: string, benefitId: string, loader: Function): Promise<string> {
		const key = variationId + '_' + benefitId;
		if (!this.map[key]) {
			let value;
			try {
				value = loader(variationId, benefitId);
			} catch (e) {
				value = Promise.resolve('');
			}
			this.map[key] = value;
			return value;
		}
		return this.map[key];
	}
}
